import React from 'react'

const github_username = 'zii4h'
const discord_usertag = 'sphy.k'
const discord_userid = '829753058082553887'
const linkedin_user = 'sophiakeziah'
const email = 'sophykeziah@gmail.com'

// GitHub repositories to fetch from API
const projects = ['zii4h/Notion-to-Jupyter']

// Custom projects (Vercel apps, external links, etc.)
const customProjects = [
	{
		name: 'Shulte Table Game',
		description: 'Just click numbers... fast!',
		link: 'https://zii4h.github.io/Schulte-Table-Game/',
		icon: 'fas fa-fw fa-rocket', // Optional: customize the icon
	},

	// {
	// 	name: 'My Vercel App',
	// 	description: 'Description of your Vercel deployed project',
	// 	link: 'https://zii4h.vercel.app/',
	// 	icon: 'fas fa-fw fa-rocket', // Optional: customize the icon
	// },
]

const links = [
	{
		name: 'GitHub',
		icon: 'fab fa-fw fa-github',
		link: `https://github.com/${github_username}`,
		description: 'My profile on GitHub',
	},
	{
		name: 'LinkedIn',
		link: `https://www.linkedin.com/in/${linkedin_user}/`,
		icon: 'fab fa-fw fa-linkedin',
		description: 'Connect with me on LinkedIn!',
	},
	{
		name: 'Discord',
		link: `https://discord.com/users/${discord_userid}`,
		icon: 'fab fa-fw fa-discord',
		description: `${discord_usertag} | Add me as friend!`,
	},
]

const info = (
	<>
		<p>
			Heyya! I'm a Computer Science student who's slightly addicted to
			coffee. ☕
		</p>
		<br></br>
		<p>
			• I'm currently exploring{' '}
			<span className="highlighted">data wrangling</span>,{' '}
			<span className="highlighted">schema design</span>, and{' '}
			<span className="highlighted">query optimization</span> — all
			database concepts with SQL and DBMS like{' '}
			<span className="highlighted">MySQL</span>,{' '}
			<span className="highlighted">PostgreSQL</span>, and others.
		</p>
		<p>
			• Basically I enjoy making sense of messy data and building
			well-structured databases. It's a journey I'm all in for :D
			<br></br>• When I'm not busy coding, you can find me immersed in a
			book, unwinding with a cup of coffee or watching movies. Life's
			never dull!
		</p>
		<p>
			• Aside from that, I am also into{' '}
			<span className="highlighted">web designing</span> and have helped
			clients showcase their brand with ready-to-use websites that fit
			their needs! With tools like{' '}
			<span className="highlighted">Figma</span>,{' '}
			<span className="highlighted">Framer</span>, and others. All cheers
			to coffee and curiosity! ✨
		</p>
	</>
)

export {
	github_username,
	discord_usertag,
	discord_userid,
	email,
	projects,
	customProjects,
	links,
	info,
}
